
<template>
  <!-- This file will edit the event object. The Event Object looks like this:
    event: {
        "_id": "event_B5xpdxvJC9XA",
        "isFinal": true,
        "events": [
            {
                "scores": [
                    0,
                    0
                ],
                "eventType": "info",
                "description": "The event has started",
                "priority": 1,
                "players": [],
                "time": 1622307833.364,
                "teamID": -1
            },
            {
                "time": 1622307833.364,
                "change": 1,
                "priority": 1,
                "eventType": "add",
                "teamID": 0,
                "players": [],
                "dataPoint": "score",
                "description": "scored 1 point",
                "value": 1,
                "scores": [
                    1,
                    0
                ]
            },
            {
                "teamID": 0,
                "players": [],
                "value": 2,
                "eventType": "add",
                "change": 1,
                "scores": [
                    2,
                    0
                ],
                "dataPoint": "score",
                "time": 1622308007.754,
                "priority": 1,
                "description": "scored 1 point"
            },
            {
                "priority": 1,
                "dataPoint": "score",
                "description": "scored 1 point",
                "value": 1,
                "eventType": "add",
                "time": 1622308336.033,
                "scores": [
                    2,
                    1
                ],
                "change": 1,
                "teamID": 1,
                "players": []
            },
            {
                "players": [],
                "eventType": "add",
                "dataPoint": "score",
                "description": "scored 1 point",
                "teamID": 0,
                "scores": [
                    3,
                    1
                ],
                "change": 1,
                "value": 3,
                "priority": 1,
                "time": 1622308483.558
            }
        ],
        "timeStart": 1622307593.4275331,
        "global": {
            "sport": "Football",
            "brand": "SeasonCast",
            "extraText": "Gilbert High School"
        },
        "id": "event_B5xpdxvJC9XA",
        "timeCreated": 1622307594.55,
        "source": "live-cache",
        "timeStop": 1622307833.363,
        "teams": [
            {
                "color": "#FFC500",
                "name": "Gilbert",
                "id": "team_MNseuRgzG",
                "score": 3
            },
            {
                "score": 1,
                "id": "team_HZj7fPnE3",
                "name": "Vista",
                "color": "#20008B"
            }
        ],
        "associated": {
            "name": "Gilbert High School",
            "id": "tigerstrong",
            "teams": [
                "team_MNseuRgzG",
                "team_HZj7fPnE3"
            ],
            "app": "seasoncast"
        },
        "timeLastEdit": 1622307833.363,
        "isActive": false,
        "eventName": "Gilbert vs Visra",
        "recordings": [
            {
                "session": "recording_sDlH7nsWJgPSrRLuX9NH",
                "title": "Gilbert vs Visra",
                "views": 15,
                "event": "event_B5xpdxvJC9XA",
                "onPub": 1622309132000,
                "duration": 1569,
                "status": 0,
                "type": "recording",
                "timeStart": [
                    {
                        "time": 0,
                        "ts": 1622307606
                    }
                ]
            }
        ]
    }
    -->
  <div class="container">
    <br />
    <h2>Edit Event</h2>
    <hr />
     <a class="btn btn-dark" v-bind:href="'/broadcaster/event/'+event.id">View Event</a><br /><br />
    <div class="seasoncast-card" style="margin-bottom:1em;" v-if="event">
        <!-- In small red text, let the user know that after 7 days events might not be editable, only show if event is older based on event.timeCreated -->
<div v-if="event.timeCreated * 1000 < (new Date()).getTime() - (7 * 24 * 60 * 60 * 1000)">
    <div class="alert alert-danger" role="alert">
        <!-- font awesome error icon -->
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span class="sr-only">Error:</span>
        This event is past the 7 day limit. It may not be editable.
    </div>
</div>
<div v-else class="alert alert-info" role="alert">
    <!-- font awesome info icon -->
    <i class="fa fa-info-circle" aria-hidden="true"></i>
        <span class="sr-only">Error:</span>
        We recommend that you score events on LockerStats.com or GameBee.io. Only edit events here if you are sure you know what you are doing. Some properties are not editable. Scores may take over 24 hours to update.
    </div>
        <vue-json-editor v-model="event" :show-btns="true" :expandedOnStart="false" @json-change="onJsonChange" :schema="eventSchema" @json-save="updateEvent" ></vue-json-editor>


    </div>
  </div>
</template>

<script>
let API = "https://app.seasoncast.com/"
import axios from "axios"
import Swal from "sweetalert2"
  import vueJsonEditor from '../helpers/vue-json-editor.vue'
  export default {
    props: ['channel'],
    data () {
      return {
        json: {
          msg: ' jsoneditor'
        },
        eventPin: undefined,
        event: null,
        eventSchema: {
          "type": "object",
          "properties": {
            "global": {
              "type": "object",
              "properties": {
                "sport": {
                  "type": "string",
                  "title": "Sport"
                },
                "brand": {
                  "type": "string",
                  "title": "Brand"
                },
                "extraText": {
                  "type": "string",
                  "title": "Extra Text"
                }
              },
              "required": [
                "sport",
                "brand",
              ]
            },
            "id": {
              "type": "string",
              "title": "ID"
            },
            "timeCreated": {
              "type": "number",
              "title": "Time Created"
            },
            "source": {
              "type": "string",
              "title": "Source"
            },
            "timeStop": {
              "type": "number",
              "title": "Time Stop"
            },
            "timeStart": {
              "type": "number",
              "title": "Time Start"
            },
            "teams": {
              "type": "array",
              "title": "Teams",
              "items": {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "string",
                    "title": "ID"
                  },
                  "name": {
                    "type": "string",
                    "title": "Name"
                  },
                  "color": {
                    "type": "string",
                    "title": "Color"
                  },
                  "score": {
                    "type": "number",
                    "title": "Score"
                  }
                },
                "required": [
                  "name",
                  "color",
                  "score"
                ]
              }
            },
            "associated": {
              "type": "object",
              "title": "Associated",
              "properties": {
                "name": {
                  "type": "string",
                  "title": "Name"
                },
                "id": {
                  "type": "string",
                  "title": "ID"
                },
                "teams": {
                  "type": "array",
                  "title": "Teams",
                  "items": {
                    "type": "string",
                    "title": "Team"
                  }
                },
                "app": {
                  "type": "string",
                  "title": "App"
                }
              },
              "required": [
                "name",
                "id",
                "app"
              ]
            },
            "timeLastEdit": {
              "type": "number",
              "title": "Time Last Edit"
            },
            "isActive": {
              "type": "boolean",
              "title": "Is Active"
            },
            "eventName": {
              "type": "string",
              "title": "Event Name"
            },
            "recordings": {
              "type": "array",
              "title": "Recordings",
              "items": {
                "type": "object",
                "properties": {
                  "session": {
                    "type": "string",
                    "title": "Session"
                  },
                  "title": {
                    "type": "string",
                    "title": "Title"
                  },
                  "views": {
                    "type": "number",
                    "title": "Views"
                  },
                  "event": {
                    "type": "string",
                    "title": "Event"
                  },
                  "onPub": {
                    "type": "number",
                    "title": "On Pub"
                  },
                  "duration": {
                    "type": "number",
                    "title": "Duration"
                  },
                  "status": {
                    "type": "number",
                    "title": "Status"
                  },
                  "type": {
                    "type": "string",
                    "title": "Type"
                  },
                  "timeStart": {
                    "type": "array",
                    "title": "Time Start",
                    "items": {
                      "type": "object",
                      "properties": {
                        "time": {
                          "type": "number",
                          "title": "Time"
                        },
                        "ts": {
                          "type": "number",
                          "title": "TS"
                        }
                      },
                      "required": [
                        "time",
                        "ts"
                      ]
                    }
                  }
                },
                "required": [   
                  "session",
                  "title",
                  "views",
                  "event",
                  "onPub",
                  "duration",
                  "status",
                  "type",
                  "timeStart"
                ]
              }
            }
          },
          "required": [
            "global",
            "id",
            "timeCreated",
            "timeStop",
            "timeStart",
            "teams",
            "associated",
            "timeLastEdit",
            "isActive",
            "eventName"
          ]
        }
      }
    },
    created: async function () {
    this.getChannelEvent()
    this.getEventPin()
    },
    components: {
      vueJsonEditor
    },

    methods: {
      onJsonChange (value) {
        console.log('value:', value)
        this.validateEvent(value)
      },
      // function vaildates the event object for updating using schema
      validateEvent (event) {
         var validate = require('jsonschema').validate;
         
         const result = validate(event, this.eventSchema);
         return result;
      },
      // function that updates event to https://timeline.seasoncast.com/v1/event/edit
      updateEvent: async function (event) {
          if (!this.eventPin) {
            Swal.fire({
              title: 'No pin to update event',
              text: 'Please validate you can edit this event',
              type: 'error',
              confirmButtonText: 'Ok'
            });
            return
          }

          // id and _id need to stay the same as props
          if (event.id !== this.$route.params.option){
            Swal.fire({
              title: 'Event ID and _id do not match',
              text: 'Please check your event id',
              type: 'error',
              confirmButtonText: 'Ok'
            });
            return
          }
        try {
            let schemaVaildate = this.validateEvent(event)
            if (!schemaVaildate.valid){
             const listOfIssues = schemaVaildate.errors.map(function (error) {
                return error.stack;
              });
              Swal.fire({
                title: 'Invalid Event',
                text: 'Please check the following errors:' + listOfIssues,
                type: 'error',
                confirmButtonText: 'Ok'
              });
              return
            }

            let getEventResponse = await axios.post("https://timeline.seasoncast.com/v1/event/edit", {...event, pin: this.eventPin});

            if (getEventResponse.status == 200) {
                console.log('Event updated successfully');

                Swal.fire({
                    title: 'Event Updated',
                    text: 'Event updated successfully',
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                console.log('Error updating event');
                Swal.fire({
                    title: 'Error Updating Event',
                    text: 'Error updating event',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (err) {
            console.log('Error updating event');
            Swal.fire({
                title: 'Error Updating Event',
                text: 'Error updating event',
                type: 'error',
                timer: 2000,
                showConfirmButton: false
            });
        }
      },
      // function that gets event pin from /v2/broadcaster/event/pin
      getEventPin: async function () {
        try {
            let getEventPinResponse = await axios.post(API+'v2/broadcaster/event/pin', {
                ...this.$store.state.broadcasterAuth,
                event_id: this.$route.params.option
            });
            if (getEventPinResponse.data.success == true) {
                console.log('Event pin found');
                this.eventPin = getEventPinResponse.data.pin;
            } else {
                console.log('Error getting event pin');
            }
        } catch (err) {
            console.log('Error getting event pin');
        }
      },

      // get event from seasoncast endpoint /v2/event 
      getChannelEvent: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/channel/event", {
    channel_id: this.channel.id,
    event_id: this.$route.params.option
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)

delete responseData.eventData.recordings
delete responseData.eventData.source
  this.event = responseData.eventData
  
  if (this.event.deleted){
    this.event = undefined
  await Swal.fire({
  icon: 'info',
  title: 'This event was deleted!',
  text: 'This event no longer exist'
})
this.$router.push('/broadcaster/events');
  }
    },
    }
  }
</script>

<style>

</style>